import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getDroneJobs } from "../../redux/slice/droneJobsSlice";
import loction_icon from "../../assets/image/png/loction_icon.png";
import Map from "../common/Map";
import AllCourses from "../CoursesDetailePage/AllCourses";

const DroneJob = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { droneJobs } = useSelector((state) => state.droneJob);
  const [activeButton, setActiveButton] = useState("map"); // Default to map view
  const [isListMode, setIsListMode] = useState(false); // To toggle between list and map view

  useEffect(() => {
    dispatch(getDroneJobs({ page: 1, limit: 4 }));
  }, [dispatch]);

  const handleButtonClick = (button) => {
    setActiveButton(button);
    if (button === "list") {
      setIsListMode(true);
    } else {
      setIsListMode(false);
    }
  };

  return (
    <div></div>
    // <div className="py-5" >
    //   <div className="container">
    //     <h3 className="mb-0 fs_43 ff_inter text-center fw-bold color_darkgray">
    //       Explore Job Opportunities with
    //       <span className=""  style={{color: "#2596be"}}> Drone Planet</span>
    //     </h3>
    //     <div className="row">
    //       {droneJobs?.map((item, index) => {
    //         return index < 4 ? (
    //           <div key={index} className="col-lg-3 col-sm-6 mt-4 pt-1">
    //             <div
    //               onClick={() => navigate(`/jobs-hire-detail-page/${item._id}`)}
    //               className="droneJob_box cursor_pointer d-flex flex-column justify-content-between p-4"
    //             >
    //               <div className="d-flex justify-content-between align-items-center">
    //                 <button className="ff_inter fs_10 job_btn border-0 p-2 text-white fw-bold">
    //                   Job Opening
    //                 </button>
    //                 <img
    //                   width={60}
    //                   className="bg-white p-1 rounded-3"
    //                   src={item.image}
    //                   alt="tech_eagle"
    //                 />
    //               </div>
    //               <div className="py-4">
    //                 <h4 className="fs_18 ff_inter mb-0 fw-bold color_darkgray">
    //                   {item.title}
    //                 </h4>
    //                 <p className="fs_15 ff_inter fw-medium mt-1 mb-2 color_darkgray">
    //                   {item.subTitle}
    //                 </p>
    //                 <p className="fs_12 ff_inter fw-bold mb-0 color_darkgray">
    //                   {item.date}
    //                 </p>
    //               </div>
    //               <div className="d-flex align-items-center gap-1">
    //                 <img width={20} src={loction_icon} alt="loction_icon" />
    //                 <span className="fs_12 ff_inter fw-medium">
    //                   {item.locationName}
    //                 </span>
    //               </div>
    //             </div>
    //           </div>
    //         ) : null;
    //       })}
    //       <div className="d-flex justify-content-center mt-4">
    //         <Link
    //           to="/jobs-hire-page"
    //           className="viewall_btn ff_inter fs_17 fw-medium text-white border-0"
    //         >
    //           View All
    //         </Link>
    //       </div>
    //     </div>
    //     {/* <h3 className="mt-5 pt-lg-4 text-center mb-0 fs_43 ff_inter color_darkgray fw-bold">
    //       Begin Your <span className=""  style={{color: "#2596be"}}>DGCA Certified</span> Drone
    //       <br className="d-lg-block d-none" />
    //       Pilot Training Today
    //     </h3>
    //     <div className="d-flex justify-content-center gap-3 mt-3">
    //       <button
    //         className={`btn btn-primary ${activeButton === 'map' ? 'active' : ''}`}
    //         onClick={() => handleButtonClick('map')}
    //       >
    //         Show on Map
    //       </button>
    //       <button
    //         className={`btn btn-primary ${activeButton === 'list' ? 'active' : ''}`}
    //         onClick={() => handleButtonClick('list')}
    //       >
    //         Show List
    //       </button>
    //     </div>
    //     {activeButton === "map" ? (
    //       <Map />
    //     ) : (
    //       <AllCourses limit={4} isListMode={isListMode} />
    //     )} */}
    //   </div>
    // </div>
  );
};

export default DroneJob;
